export default "/assets/images/screen-01.66c92b781153304c.png";